import { validator } from "@/utils/validator";

// The new email must be a valid address and differ from the current one.
// Cross-org duplicate detection is enforced server-side (EMAIL_HAS_BEEN_ALREADY_EXISTS on submit).
export const buildChangeEmailFormSchema = (currentEmail: string) =>
  validator.object().shape({
    newEmail: validator
      .string()
      .trim()
      .emptyToNull()
      .autoTransformToHalfWidth()
      .email()
      .notOneOf([currentEmail], "現在のメールアドレスと異なるメールアドレスを入力してください。")
      .label("新しいメールアドレス")
      .required(),
  });
